import { Scenarios } from '@jfs/network'

const validateIfscCode = {
  default: [
    {
      url: /validateIFSC/,
      method: 'POST',
      response: {
        ifscCode: 'PUNB0112000',
        bankName: 'PUNJAB NATIONAL BANK',
        branchName: 'ECE HOUSE NEW DELHI',
        bankCity: 'ECE HOUSE NEW DELHI',
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /validateIFSC/,
      method: 'POST',
      responseCode: 501,
      response: { status: 'FAILURE', error: { code: '33607', message: 'INVALID.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { validateIfscCode }
